import useData from "./useData";
import { useEffect, useMemo, useState } from "react";

const useReceiving = (pageOffset?: number, pageSize?: number, refetchInterval?: false | number) => {
    const [selection, setSelection] = useState<string | number | null>(null);

    const {
        data,
        ...others
    } = useData('/1.0/receivelist', {
        pageOffset,
        pageSize: pageSize || 100,
        refetchInterval
    });

    const {
        data: receiveListLinesData,
        isLoading: isLoadingLines,
        setFilter: setReceiveingListLinesFilter,
    } = useData('/1.0/receivelistlines', {
        pageOffset,
        pageSize,
        requireFilter: true
    });

    const receivingLists = useMemo(() => data.map((row: any) => ({
        id: row.receivelist,
        lockedbystr: (row.lockedbyemployeename ? row.lockedbyemployeename + ' @ ' + row.lockedby : row.lockedby),
        ...row,
    })), [data]);

    const receivingListLines = useMemo(() => receiveListLinesData.map((row: any) => ({
        id: row.receivelist + '_' + row.orderline,
        ...row,
    })), [receiveListLinesData]);

    const stats = useMemo(() => ({
        ...receivingLists.reduce((acc, row) => {
            const delDate = new Date(row.deldate);
            const today = new Date();

            acc.total++;
            acc.orderlines += row.orderlines || 0;
            acc.remainingreceiptquantity += row.remainingreceiptquantity || 0;
            if (delDate < today || delDate.toISOString().split('T')[0] === today.toISOString().split('T')[0]) {
                acc.totalToday++;
                acc.orderlinesToday += row.orderlines || 0;
                acc.remainingreceiptquantityToday += row.remainingreceiptquantity || 0;
            }
            return acc;
        }, {
            total: 0,
            totalToday: 0,
            orderlines: 0,
            remainingreceiptquantity: 0,
            orderlinesToday: 0,
            remainingreceiptquantityToday: 0,
        }),
    }), [receivingLists]);

    useEffect(() => {
        if (selection) {
            setReceiveingListLinesFilter('receivelist', { property: 'receivelist', value: selection });
        }
    }, [selection, setReceiveingListLinesFilter])

    return {
        receivingLists,
        receivingListLines,
        isLoadingLines,
        setSelection,
        stats,
        ...others
    }
}

export default useReceiving;